import { render, staticRenderFns } from "./TeprosifForm.vue?vue&type=template&id=2d9a6b0a"
import script from "./TeprosifForm.vue?vue&type=script&lang=js"
export * from "./TeprosifForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports